import { openDB } from 'idb'
import type { PendingMutation } from '../types/crm'

const database = openDB('digi-enseignes-offline', 1, {
  upgrade(db) {
    db.createObjectStore('cache')
    db.createObjectStore('mutations', { keyPath: 'id' })
  },
})

export async function readCache<T>(key: string): Promise<T | undefined> {
  return (await database).get('cache', key) as Promise<T | undefined>
}

export async function writeCache(key: string, value: unknown): Promise<void> {
  await (await database).put('cache', value, key)
}

export async function queueMutation(mutation: PendingMutation): Promise<void> {
  await (await database).put('mutations', mutation)
  window.dispatchEvent(new CustomEvent('digi-sync-change'))
}

export async function pendingCount(): Promise<number> {
  return (await database).count('mutations')
}

export async function flushMutations(): Promise<void> {
  if (!navigator.onLine) return
  const db = await database
  const queued = await db.getAll('mutations') as PendingMutation[]
  for (const mutation of queued) {
    const response = await fetch(mutation.url, {
      method: mutation.method,
      headers: mutation.body === undefined ? undefined : { 'Content-Type': 'application/json' },
      body: mutation.body === undefined ? undefined : JSON.stringify(mutation.body),
    })
    if (!response.ok) throw new Error(`Synchronisation refusée (${response.status})`)
    await db.delete('mutations', mutation.id)
  }
  window.dispatchEvent(new CustomEvent('digi-sync-change'))
}
